import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/digithia-logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-1cf21c18")

_pushScopeId("data-v-1cf21c18")
const _hoisted_1 = { class: "login" }
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  slot: "logo",
  src: _imports_0,
  class: "logo"
}, null, -1)
const _hoisted_3 = {
  slot: "title",
  class: "center title-2"
}
const _hoisted_4 = {
  slot: "form",
  class: "login-form"
}
const _hoisted_5 = { class: "center title-3" }
const _hoisted_6 = {
  slot: "links",
  class: "link"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("dig-ui-login-card", _hoisted_1, [
    _hoisted_2,
    _createVNode("dig-ui-title", _hoisted_3, _toDisplayString(_ctx.$t('loginTitle')), 1),
    _createVNode("div", _hoisted_4, [
      _createVNode("dig-ui-title", _hoisted_5, _toDisplayString(_ctx.$t('loginSubtitle')), 1),
      _createVNode("dig-input-text", {
        value: $setup.username,
        onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.username = $event.target.value)),
        onKeyup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.keydownLogin && $setup.keydownLogin(...args))),
        required: "",
        id: "username"
      }, _toDisplayString(_ctx.$t('usernameOrEmail')), 41, ["value"]),
      _createVNode("dig-input-text", {
        value: $setup.password,
        onInput: _cache[3] || (_cache[3] = ($event: any) => ($setup.password = $event.target.value)),
        onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.keydownLogin && $setup.keydownLogin(...args))),
        required: "",
        type: "password",
        id: "password",
        name: "password",
        autocomplete: "off"
      }, _toDisplayString(_ctx.$t('password')), 41, ["value"]),
      _createVNode("input", {
        type: "text",
        value: $setup.username,
        onInput: _cache[5] || (_cache[5] = ($event: any) => ($setup.username = $event.target.value)),
        hidden: true
      }, null, 40, ["value"]),
      _createVNode("input", {
        type: "password",
        value: $setup.password,
        onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.password = $event.target.value)),
        hidden: true
      }, null, 40, ["value"]),
      _createVNode("div", null, [
        _createVNode("dig-ui-standard-button", {
          disabled: $setup.loading,
          onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.login()))
        }, _toDisplayString(_ctx.$t('connection')), 9, ["disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode(_component_router_link, { to: { name: 'AskResetPassword' } }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('forgotMyPassword')), 1)
        ]),
        _: 1
      })
    ])
  ]))
})